"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
 //# sourceMappingURL=SpinButton.types.js.map

//# sourceMappingURL=SpinButton.types.js.map